import { I18nManager } from "react-native";
import React, {useState} from 'react';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Button, Divider, Layout, Text, Icon, Card } from '@ui-kitten/components';
import { StyleSheet, ScrollView, TouchableOpacity, View, Dimensions } from 'react-native';
import moment from 'jalali-moment'
import { showMessage, hideMessage } from "react-native-flash-message";
import * as RootNavigation from '../../../root.navigation.js';
import trackerApi from '../../api/tracker';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { useIsFocused } from "@react-navigation/native";
const width = Dimensions.get('window').width;

const month = [
  'فروردین',
  'اردیبهشت',
  'خرداد',
  'تیر',
  'مرداد',
  'شهریور',
  'مهـر',
  'آبان',
  'آذر',
  'دی',
  'بهمن',
  'اسفند'
]
const MoreIcon = (props) => (
  <Icon {...props}
    style={[props.style, {width:48,height:48, marginTop:5 }]}
    fill='#e3e3e3'
    name='arrowhead-left'/>
);
const DoneIcon = (props) => (
  <Icon {...props}
    style={[props.style, {width:36,height:36, marginTop:5}]}
    fill = '#f5f5f5'
    name='checkmark-square'/>
);
const BellIcon = (props) => (
  <Icon {...props}
    style={[props.style, {width:36,height:36, marginTop:5}]}
    fill = '#f5f5f5'
    name='bell'/>
);
export const News =  () => {
  const [data, setData] = React.useState([]);
  const isVisible = useIsFocused();

  const getData = async ()=>{
    const token =  await AsyncStorage.getItem('userId');

    const q = {
          q: '',
          page: 1,
          status: '',
          sort: 'desc',
          perPage: 3,
          sortColumn: 'id'
        }
    const response = await trackerApi.post('/get/news', {q} , {
      headers: {Authorization: `Bearer ${token}`}
    });
    setData(response.data.allData);
  }

  React.useEffect(()=>{
    getData()
  },[isVisible])

  return (


      <Layout level='2' style={styles.container}>
      <ScrollView
        horizontal
        style={{ flexDirection: I18nManager.isRTL ? 'row-reverse' : 'row' }}
        showsHorizontalScrollIndicator={false} >
        {

          data.map((data)=>{
            if(data.enabled && data.priority=='pin') return(
              <Layout style={{marginHorizontal:5}}>
            <TouchableOpacity style={styles.card1} key={data.id}  onPress={() => {RootNavigation.navigate('SingleNews', {news:data})}}>
              <View style={{flexDirection:'row',justifyContent:'space-between', alignItems:'flex-start'}}>
                <Text category='c2' appearance='hint'>{ data.create_date ? data.create_date.split('T')[0].split('/')[2] : 0} {month[data.create_date ? Number(data.create_date.split('T')[0].split('/')[1].split('/')[0])-1 : 0]}</Text>
              </View>

              <View style={{flex:1, alignItems:'flex-start', marginTop:8, minHeight: 8, marginBottom: 10}}>
                <Text category='h6' numberOfLines={1} ellipsizeMode='head'>{ ((data.title).length > 22) ?
                  (((data.title).substring(0,19)) + '...') :
                  data.title }</Text>
              </View>
            </TouchableOpacity>
            </Layout>
          )
          })
        }

        {
          data.map((data)=>{
            if( data.enabled && data.priority!='pin') return(
              <Layout>
            <TouchableOpacity style={styles.card1} key={data.id}  onPress={() => {RootNavigation.navigate('SingleNews', {news:data})}}>
              <View style={{flexDirection:'row',justifyContent:'space-between', alignItems:'flex-start'}}>
                <Text category='c2' appearance='hint'>{data.create_date.split('T')[0].split('/')[2]} {month[Number(data.create_date.split('T')[0].split('/')[1].split('/')[0])-1]}</Text>
              </View>

              <View style={{flex:1, alignItems:'flex-start', marginTop:8, minHeight: 8,  marginBottom: 10}}>
                <Text category='h6'>
                { ((data.title).length > 22) ?
                  (((data.title).substring(0,19)) + '...') :
                  data.title }
                </Text>
              </View>

            </TouchableOpacity>
            </Layout>
          )
          })
        }


      { data.length >0 &&
        <TouchableOpacity
            level='2'
            style={{alignItems:'center', justifyContent:'center'}}
            onPress={() => {
          /* HERE IS WHERE WE'RE GOING TO SHOW OUR FIRST MESSAGE */
            RootNavigation.navigate('News')}}
            >
            <MoreIcon />
            <Text appearance='hint' category='c2'>بیشتر</Text>
          </TouchableOpacity>
        }
        </ScrollView>

      </Layout>



  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    paddingHorizontal:10,
    justifyContent:'flex-start',
    alignItems:'flex-start'
  },
  card1: {

    borderRadius:10,
    justifyContent: 'flex-start',
    alignItems:'flex-start',
    borderWidth:1,
    borderColor: '#9ecbff',
    width: width*0.6,
    padding: 5
  },
  card2: {
    marginRight: 5,
    marginLeft:5,
    marginVertical:5,
    borderRadius:10,
    height:120,
    width:100,
    flexDirection:'row',
    paddingHorizontal:10,
    paddingTop:5,
    justifyContent: 'space-between',
    alignItems:'flex-start',
    flex:1,
  },
  text:{
    color:'#f5f5f5',
  }

});
